// LIBRERIE/IMPORTS
import React, {useState, useEffect} from "react";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import he from 'he';

// HOOKS
import { useTranslation } from "react-i18next";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";

const imagesCarouselPath = [
    "/assets/images/altrePag/aboutUs1.jpg",
    "/assets/images/altrePag/aboutUs2.jpg",
    "/assets/images/altrePag/aboutUs3.jpg",
    "/assets/images/altrePag/aboutUs4.jpg",
    "/assets/images/altrePag/aboutUs5.jpg",
];


interface AboutUsProps {
    agencyId: number;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId }) => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    // Impostazioni carosello
    const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);
    const [slidesToShow, setSlidesToShow] = useState<number>(1);

    useEffect(() => {
        const handleResize = () => setInnerWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (innerWidth >= 992) {
            setSlidesToShow(2);
        } else {
            setSlidesToShow(1);
        }
    }, [innerWidth]);

    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1200,
        cssEase: "ease-in-out",
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false
    };

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.head.metaTitle')} | {he.decode(`${agency?.agencyName}`)}</title>
                <meta name="description" content={t('aboutUsPage.head.metaDescription') as string} />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb">
                <div className="container-fluid w-special">

                    <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }}></p>

                    <div className="slider-container img-wrapper mt-4">
                        <Slider {...sliderSettings}>
                            {imagesCarouselPath.map((imagePath, index) => (
                                <div key={index} className="slider-image-wrapper">
                                    <img src={imagePath} alt={`chi siamo ${index + 1}`} className="slider-image" />
                                </div>
                            ))}
                        </Slider>
                    </div>

                </div>
            </main>
        </>
    );
};
export default AboutUs;